import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { saveCartItem, deleteOrder, checkout } from '../../../actions/cart';
import { getContactInfo, getContactUsername } from '../../../actions/checkout';
import history from '../../../history';
import { redirectToUrl } from '../../../utils/navigation';
import { STEP_FORM_FIELDS } from './fields/stepFields';

export default function WizardButtons(props) {
  const [submitLoader, setSubmitLoader] = useState(false);

  const order = useSelector((state) => state.cart.order);
  const loggedIn = useSelector((state) => state.cart.loggedIn);

  const cartItems = useSelector((state) => state.cart.cart.cartItems);
  const contactInfo = useSelector((state) => state.checkout.contactInfo);
  const contactUsernameDetails = useSelector((state) => state.checkout.contactUsernameDetails);
  const registration = useSelector((state) => state.registration);

  const dispatch = useDispatch();

  /* istanbul ignore next */
  const _redirectStepUrl = (currentStep) => {
    let url = '';

    switch (currentStep) {
      case 2:
        url = 'help-me-choose-2';
        break;
      case 3:
        url = 'help-me-choose-3';
        break;
      default:
        url = 'help-me-choose';
        break;
    }

    history.push(url);
  };

  /* istanbul ignore next */
  const _next = () => {
    if (props.handleValidation(true)) {
      props.trackStep('Next', props.currentStep);
      props.trackStepResponse(props.currentStep, props.inputValues);
      let currentStep = props.currentStep >= 2 ? 3 : props.currentStep + 1;
      props.setCurrentStep(currentStep);
      _redirectStepUrl(currentStep);
    }
  };

  /* istanbul ignore next */
  const _prev = () => {
    props.trackStep('Back', props.currentStep);
    props.trackStepResponse(props.currentStep, props.inputValues);
    let currentStep = props.currentStep <= 1 ? 1 : props.currentStep - 1;
    props.setCurrentStep(currentStep);
    history.goBack();
  };

  /*
   * the functions for our button
   */
  /* istanbul ignore next */
  const previousButton = () => {
    if (props.currentStep > 1 && props.currentStep < 4) {
      return (
        <a className='btn btn-outline-primary wizard-btn' type='button' onClick={_prev}>
          Back
        </a>
      );
    }
    return null;
  };

  /* istanbul ignore next */
  const nextButton = () => {
    if (props.currentStep < 3) {
      return (
        <button className={'btn btn-primary float-right wizard-btn'} type='button' onClick={_next}>
          Next
        </button>
      );
    }
    return null;
  };

  /* istanbul ignore next */
  const submitButton = () => {
    if (props.currentStep === 3) {
      return (
        <button
          className={
            !props.isValid
              ? 'btn btn-primary disabled float-right wizard-btn'
              : 'btn btn-primary float-right wizard-btn'
          }
          type='button'
          onClick={(e) => {
            props.trackStep('Finish', props.currentStep);
            props.trackStepResponse(props.currentStep, props.inputValues);
            props.handleSubmit(e, true);
          }}
        >
          Finish
        </button>
      );
    }
    // props.scrollToTop()
    return null;
  };

  /* istanbul ignore next */
  function setCustomerDetails() {
    dispatch(getContactInfo()).then(function (contactInfoAction) {
      const currentContactInfo = (contactInfoAction && contactInfoAction.data) ? contactInfoAction.data : contactInfo;
      let products = cartItems;
      let customer = {
        industry: 'NONE'
      };
      if (currentContactInfo) {
        if (currentContactInfo.emailAddress) {
          customer.email = currentContactInfo.emailAddress;
        }
        if (currentContactInfo.firstName) {
          customer.name = `${currentContactInfo.firstName} `;
        }
        if (currentContactInfo.lastName) {
          customer.name += currentContactInfo.lastName;
        }
        if (currentContactInfo.mobileNumber) {
          customer.mobileNumber = currentContactInfo.mobileNumber;
        }

        if (customer.email) {
          dispatch(getContactUsername(customer.email)).then(function (usernameAction) {
            const currentUsernameDetails = (usernameAction && usernameAction.data) ? usernameAction.data : contactUsernameDetails;
            if (currentUsernameDetails.content && currentUsernameDetails.content.length > 0) {
              customer.username = currentUsernameDetails.content[0].username
                ? currentUsernameDetails.content[0].username
                : '';
            }

            customer.claudId = registration.emailValidation.guid;

            let newOrder = {
              processStatus: 'AUTO',
              customer: customer,
              quoteConfiguration: {
                products: products
              }
            };
            dispatch(checkout(newOrder)).then(function () {
              setSubmitLoader(false);
            });
          });
        } else {
          setSubmitLoader(false);
        }
      } else {
        setSubmitLoader(false);
      }
    });
  }

  /* istanbul ignore next */
  function onCheckout() {
    if (loggedIn) {
      setCustomerDetails();
    } else {
      history.push('/register');
      setSubmitLoader(false);
    }
  }

  /* istanbul ignore next */
  function saveToCart(cartItem, action) {
    dispatch(saveCartItem(cartItem, action)).then(function () {
      if (action === 'buy') {
        onCheckout();
      } else {
        setSubmitLoader(false);
      }
    });
  }

  /* istanbul ignore next */
  function onAddToCart(action) {
    setSubmitLoader(true);
    let productId = props.product.productsConfig[props.FRIENDLY_NAME].id;

    let cartItem = {
      configuration: props.setConfigurationBlob(),
      product_id: parseInt(productId, 10)
    };

    if (order != null && Object.keys(order).length > 0) {
      dispatch(deleteOrder(cartItem)).then(function () {
        saveToCart(cartItem, action);
      });
    } else {
      saveToCart(cartItem, action);
    }
  }

  const addToCartButton = () => {
    if (props.currentStep === 4) {
      return (
        <button
          className={
            submitLoader || !props.isValid
              ? 'btn disabled btn-outline-primary float-right wizard-btn'
              : 'btn btn-outline-primary float-right wizard-btn'
          }
          onClick={() => {
            props.trackHmcwAddToCart('Add to Cart', props.inputValues);
            onAddToCart('add');
          }}
          type='button'
        >
          Add to Cart
        </button>
      );
    }
    return null;
  };

  const checkoutButton = () => {
    if (props.currentStep === 4) {
      return (
        <button
          className={
            submitLoader || !props.isValid
              ? 'btn disabled btn-primary float-right wizard-btn'
              : 'btn btn-primary float-right wizard-btn'
          }
          onClick={() => {
            props.trackHmcwAddToCart('Checkout', props.inputValues);
            onAddToCart('buy');
          }}
          type='button'
        >
          Checkout
        </button>
      );
    }
    return null;
  };

  const resetButton = () => {
    if (props.currentStep === 4) {
      return (
        <button
          id='start-again-btn'
          className='btn btn-outline-primary wizard-btn'
          onClick={() => {
            props.setHelpMeChooseInput(STEP_FORM_FIELDS);
            props.trackStep('Start Again', props.currentStep);
            redirectToUrl('/product/rp-data-professional/help-me-choose');
          }}
          type='button'
        >
          Start Again
        </button>
      );
    }
    return null;
  };

  let classNames = require('classnames');
  let errorMessageClass = classNames({
    'red-text footnote-text float-right': !props.mobile,
    'red-text footnote-text text-align-left': props.mobile
  });

  return (
    <React.Fragment>
      {!props.isValid && (
        <div className={errorMessageClass}>Please complete all the required steps.</div>
      )}
      {!props.mobile && <br />}
      {previousButton()}
      {nextButton()}
      {submitButton()}
      {resetButton()}
      {!submitLoader && (
        <span>
          {checkoutButton()}
          {addToCartButton()}
        </span>
      )}
      {submitLoader && (
        <span className='row float-right' style={{ marginTop: '0px' }}>
          <i className='fa fa-spinner fa-pulse fa-3x fa-fw'></i>
          <span className='sr-only'>Loading...</span>
        </span>
      )}
    </React.Fragment>
  );
}
